import { QRCodeCanvas as QRCode } from "qrcode.react";
import { Modal, Row, Col } from "react-bootstrap";

import "./showTag.styles.scss";

import { dateToLocale } from "@/services/Utils";

const InputSelect = ({ show, setShow, inventory }) => {
	return (
		<Modal show={show} onHide={() => setShow(false)} backdrop="static" keyboard={false} centered>
			<Modal.Header className="modal-tag-header" closeButton>
				<h4>Etiqueta</h4>
			</Modal.Header>
			<Modal.Body className="modal-tag-body">
				<Row>
					<Col xs={12}>
						<QRCode value={`1`} size={200} />
					</Col>
					<Col xs={12}>{inventory.inventory_id}</Col>
					<Col xs={12}>{inventory.tradename}</Col>
					<Col xs={12}>{inventory.expiration_date ? dateToLocale(inventory.expiration_date) : ""}</Col>
				</Row>
			</Modal.Body>
		</Modal>
	);
};

export default InputSelect;
